<div class="batch-success-notification">
  <div class="batch-notification-icon">
    <img src="/assets/icons/icon_attached.svg" />
  </div>
  <div class="batch-success-notification-text">
    <div class="batch-success-notification-text-header">{{ header | translate }}</div>
    <div class="batch-success-notification-text-hint">{{ hint | translate }}</div>
  </div>
</div>
